export default __webpack_public_path__ + "static/media/logo-horizontal.13218286.png";